import React from 'react';
import { SeoCardRow } from 'store/services/seo/publicSeoApi';
import { RankedCardRow, rankedCardHref } from './RankedCardRow';
import './RankedCardList.css';

export { rankedCardHref };

interface Props {
  title: string;
  rows: SeoCardRow[];
  /** Noun for the per-row count, e.g. "traders want it", "trades", "copies". */
  countLabel: (count: number) => string;
  emptyText?: string;
}

/**
 * One ranked list on a set landing page (Asana 1219287567650303): the rows are
 * RankedCardRow, shared with the format pages' tabbed lists. Rendered as plain
 * markup so the crawler path sees the list.
 */
const RankedCardList: React.FC<Props> = ({ title, rows, countLabel, emptyText = 'No data yet.' }) => (
  <section className="ranked-card-list" data-testid="ranked-card-list">
    <h2 className="ranked-card-list__title">{title}</h2>
    {rows.length === 0 ? (
      <p className="ranked-card-list__empty">{emptyText}</p>
    ) : (
      <ol className="ranked-card-list__rows">
        {rows.map((row, i) => (
          <RankedCardRow key={`${row.setCode}-${row.collectorNumber}-${i}`} rank={i + 1} row={row} countLabel={countLabel} />
        ))}
      </ol>
    )}
  </section>
);

export default RankedCardList;
